export default __webpack_public_path__ + "static/media/institute-27-min.c54ca2b3.webp";